module.exports = __webpack_public_path__ + "static/media/pagi-combobox-arrow.f0e4f15c.svg";